module.exports = "https://www.gc-pro.gnp.com.mx/1c6357a33d444d7aa80244ed14c02208.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_rc_EUA_25.svg
// module id = 1844
// module chunks = 0